import { CATEGORY_LIST, getCategoryById } from '../utils/categories.js';
import { uploadImage } from '../services/storage.js';
import { createReport } from '../services/reports.js';
import { showToast } from './notifications.js';
import { MAX_IMAGE_SIZE, ACCEPTED_IMAGE_TYPES } from '../utils/constants.js';
import { calculateDistance } from '../utils/helpers.js';

let selectedCategory = null;
let selectedLocation = null;
let selectedImage = null;

/**
 * Initialize the report creation modal.
 */
export function initReportModal(onReportCreated, getExistingReports) {
  const overlay = document.getElementById('report-modal');
  const closeBtn = document.getElementById('modal-close');
  const form = document.getElementById('report-form');
  const submitBtn = document.getElementById('report-submit');
  const imageInput = document.getElementById('report-image');
  const uploadArea = document.getElementById('image-upload-area');
  const preview = document.getElementById('image-preview');
  const placeholder = document.getElementById('upload-placeholder');

  // Render category options
  const catSelector = document.getElementById('category-selector');
  CATEGORY_LIST.forEach((cat) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cat-option';
    btn.dataset.category = cat.id;
    btn.style.setProperty('--cat-color', cat.color);
    btn.style.setProperty('--cat-bg', cat.colorLight);
    btn.innerHTML = `<span class="dot" style="background:${cat.color}"></span> ${cat.name}`;
    btn.addEventListener('click', () => {
      catSelector.querySelectorAll('.cat-option').forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');
      selectedCategory = cat.id;
      validateForm();
    });
    catSelector.appendChild(btn);
  });

  // Close modal
  closeBtn.addEventListener('click', () => closeModal());
  overlay.addEventListener('click', (e) => { if (e.target === overlay) closeModal(); });

  // Image upload
  uploadArea.addEventListener('click', () => imageInput.click());
  uploadArea.addEventListener('dragover', (e) => { e.preventDefault(); uploadArea.classList.add('drag-over'); });
  uploadArea.addEventListener('dragleave', () => uploadArea.classList.remove('drag-over'));
  uploadArea.addEventListener('drop', (e) => {
    e.preventDefault();
    uploadArea.classList.remove('drag-over');
    const file = e.dataTransfer.files[0];
    if (file) handleImageSelect(file);
  });
  imageInput.addEventListener('change', () => {
    if (imageInput.files[0]) handleImageSelect(imageInput.files[0]);
  });

  function handleImageSelect(file) {
    if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
      showToast('Поддерживаются только JPG, PNG, WebP', 'error');
      return;
    }
    if (file.size > MAX_IMAGE_SIZE) {
      showToast('Максимальный размер файла — 5 МБ', 'error');
      return;
    }
    selectedImage = file;
    const url = URL.createObjectURL(file);
    preview.src = url;
    preview.hidden = false;
    placeholder.hidden = true;
  }

  // Form validation
  const titleInput = document.getElementById('report-title');
  const descInput = document.getElementById('report-description');
  titleInput.addEventListener('input', validateForm);
  descInput.addEventListener('input', validateForm);

  function validateForm() {
    const valid = selectedCategory && selectedLocation && titleInput.value.trim() && descInput.value.trim();
    submitBtn.disabled = !valid;
  }

  // Submit
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    // Deduplication check
    const existing = getExistingReports ? getExistingReports() : [];
    const duplicate = existing.find(r => 
      r.category === selectedCategory && 
      calculateDistance(r.latitude, r.longitude, selectedLocation.lat, selectedLocation.lng) < 50
    );

    if (duplicate) {
      if (!confirm('Похожий отчёт уже существует в этом месте. Вы уверены, что хотите отправить ещё один?')) {
        return;
      }
    }

    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="loader-ring" style="width:18px;height:18px;border-width:2px"></span> Отправка…';

    try {
      let imageUrl = null;
      if (selectedImage) {
        imageUrl = await uploadImage(selectedImage);
      }

      const report = await createReport({
        category: selectedCategory,
        title: titleInput.value.trim(),
        description: descInput.value.trim(),
        latitude: selectedLocation.lat,
        longitude: selectedLocation.lng,
        image_url: imageUrl,
      });

      showToast('Отчёт успешно создан!', 'success');
      closeModal();
      if (onReportCreated) onReportCreated(report);
    } catch (err) {
      showToast('Ошибка при создании отчёта', 'error');
      console.error(err);
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg> Отправить отчёт`;
    }
  });
}

export function openModal(latlng) {
  selectedLocation = latlng;
  selectedCategory = null;
  selectedImage = null;

  // Reset form
  document.getElementById('report-form').reset();
  document.getElementById('image-preview').hidden = true;
  document.getElementById('upload-placeholder').hidden = false;
  document.querySelectorAll('.cat-option').forEach((b) => b.classList.remove('selected'));
  document.getElementById('report-submit').disabled = true;

  // Update location display
  const locDisplay = document.getElementById('location-display');
  const locText = document.getElementById('location-text');
  if (latlng) {
    locDisplay.classList.add('set');
    locText.textContent = `${latlng.lat.toFixed(5)}, ${latlng.lng.toFixed(5)}`;
  }

  document.getElementById('report-modal').classList.add('visible');
}

export function closeModal() {
  document.getElementById('report-modal').classList.remove('visible');
}
